import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAuthData } from "./authSlice";

export const sendProducts = createAsyncThunk(
  "payment/sendProducts",
  async ({ products, deliveryDate }, { rejectWithValue }) => {
    try {
      const authData = getAuthData();

      if (!authData.companyCode || !authData.groupCode || !authData.token) {
        throw new Error("signin");
      }

      // Group products by ID and consolidate variations
      const productMap = new Map();

      products.forEach((product) => {
        const {
          _id,
          quantity,
          meas = "",
          original_price,
          disc_perc,
          color,
          size,
          lot,
          cupsize,
        } = product;

        if (!productMap.has(_id)) {
          productMap.set(_id, {
            product_id: _id,
            qty: 0,
            meas,
            unitprice: original_price.replaceAll(",", ""),
            discount_percentage: disc_perc,
            subItems: [],
          });
        }

        const existingProduct = productMap.get(_id);
        existingProduct.qty += quantity;

        // Add variations for this product
        const variation = {};
        if (color) variation.g_color = color?.g_color;
        if (size) variation.g_size = size?.g_size;
        if (lot) variation.lot = lot?.lotno;
        if (cupsize) variation.g_cupsize = cupsize?.g_cupsize;

        variation.qty = quantity;

        existingProduct.subItems.push(variation);
      });

      // Convert the map back to an array
      const detail = Array.from(productMap.values());

      // Construct the cart object
      const cart = {
        cart: {
          aux: sessionStorage.getItem("aux"),
          curency: sessionStorage.getItem("curId"),
          address_id: sessionStorage.getItem("address_id"),
          detail: detail,
          ...(deliveryDate && { delivery_date: deliveryDate }),
        },
      };

      // Create FormData
      const formData = new FormData();
      formData.append("cart", JSON.stringify(cart));
      formData.append("source", 3);
      formData.append("token", authData?.token);
      formData.append("user", authData?.user_id);
      formData.append("company_code", authData?.companyCode);
      formData.append("group_code", authData?.groupCode);
      formData.append("type", 1);
      formData.append("pricelist", authData?.pricelist);

      // Send the POST request
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}clientPortal/CartInfo`,
        {
          method: "POST",
          body: formData,
        },
      );

      if (!response.ok) {
        throw new Error("Failed to place order");
      }

      const data = await response.json();
      if (data.error) throw new Error(data.error);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
const paymentSlice = createSlice({
  name: "payment",
  initialState: {
    sendStatus: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sendProducts.pending, (state) => {
        state.sendStatus = "loading";
      })
      .addCase(sendProducts.fulfilled, (state, action) => {
        state.sendStatus = `Success: ${action?.payload?.message}`;
        state.error = null;
      })
      .addCase(sendProducts.rejected, (state, action) => {
        state.sendStatus = "failed";
        state.error = action.payload;
      });
  },
});

export default paymentSlice.reducer;
